module.exports = __webpack_public_path__ + "img/hotel1_4.b6ec4d16.png";